import { PerformanceRatingsEnum } from "@features/enums/performance-ratings-enum";

export class PerformanceItem {
  
  constructor(
    public programmeSequenceNo: number,
    public performanceSequenceNo: number,
    public performanceItemId: string | undefined,
    public performanceItemName: string,
    public performanceId: string | undefined,
    public performanceName: string,
    public performerNameList: string[]
  ) {}

}